import { render, staticRenderFns } from "./WelcomeSplash.vue?vue&type=template&id=2bfb19a6&scoped=true&"
import script from "./WelcomeSplash.vue?vue&type=script&lang=js&"
export * from "./WelcomeSplash.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeSplash.vue?vue&type=style&index=0&id=2bfb19a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfb19a6",
  null
  
)

export default component.exports